var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "40px",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 0c141.29 0 256 114.71 256 256s-114.71 256-256 256-256-114.71-256-256 114.71-256 256-256zm153.32 178.98c-3.68-13.769-14.522-24.61-28.29-28.29-24.958-6.688-125.02-6.688-125.02-6.688s-100.07 0-125.02 6.688c-13.765 3.68-24.61 14.521-28.29 28.29-6.685 24.955-6.685 77.024-6.685 77.024s0 52.067 6.685 77.02c3.68 13.769 14.525 24.614 28.29 28.293 24.958 6.685 125.02 6.685 125.02 6.685s100.07 0 125.02-6.685c13.768-3.679 24.61-14.524 28.29-28.293 6.685-24.953 6.685-77.02 6.685-77.02s0-52.069-6.685-77.024zm-185.32 125.02v-96.002l83.137 48.001-83.137 48.001z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.dd512964b8b1edcc2e490069ccc627d8.svg";
export { ForwardRef as ReactComponent };